<template>
  <div :class="['pannel', { noExpand: !isExpand }]">
    <div class="header">
      <div class="header-menu">
        <el-tabs class="tabs" v-model="activeIndex">
          <el-tab-pane v-for="item in tabs" :key="item.tabKey" :label="item.name" :name="item.tabKey" />
        </el-tabs>
      </div>
      <div class="expand-btn" @click="isExpand = !isExpand">
        <span :class="`iconfont ${isExpand ? 'icon-xia-line' : 'icon-shang-line'}`"></span>
      </div>
    </div>
    <div class="content">
      <template v-if="showIframe">
        <iframe
          v-for="tab in tabs"
          :key="`${tab.tabKey}_${reloadCount[tab.tabKey] || 0}`"
          ref="callPopScreenTabIframe"
          v-show="tab.tabKey === activeIndex"
          :src="srcCache[tab.tabKey]"
          frameborder="0"
          width="100%"
          height="100%"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash'
import { getShortId } from '@/utils'
const isValidVal = (val) => {
  return ![undefined, null].includes(val)
}
export default {
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    isQidianShowWo: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      showIframe: true,
      isExpand: true,
      // 当前激活 tab 的唯一标识(tabKey), 不使用数组下标, 避免过滤后错位
      activeIndex: undefined,
      // 每个 tab 对应 iframe 的 src 缓存(is_refresh=0 的 tab 切换时复用, 不刷新)
      srcCache: {},
      // 每个 tab 的刷新次数, 变化时改变 iframe 的 key 强制重建刷新
      reloadCount: {}
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    tabs() {
      const { call_type } = this.item
      const rawTabs = this.config.tabs || []
      // config.tabs 引用变化时, 为每个原始 tab 生成一次稳定的唯一 tabKey
      // (不依赖 name; item/过滤条件变化引起重算时 id 不变, 避免保活的 iframe 被误重建)
      if(this._rawTabsRef !== rawTabs) {
        this._rawTabsRef = rawTabs
        this._tabIdMap = rawTabs.map(() => getShortId(10, 'tab_'))
      }
      const keptIndexes = []
      rawTabs.forEach((item, index) => {
        // 过滤掉工单
        if (item.name === '工单') {
          if(this.isQidianShowWo) {
            keptIndexes.push(index)
          }
          return
        }
        // 如何配置了呼入呼出条件,  // 1-呼出, 2-呼入
        if(item.condition && item.condition.call_type) {
          if(item.condition.call_type === 1 && call_type !== 1) {
            return
          }
          if(item.condition.call_type !== 1 && call_type === 1) {
            return
          }
        }
        if(item.enable) {
          keptIndexes.push(index)
        }
      })
      // 返回附带稳定 tabKey 的副本
      return keptIndexes.map((index) => ({
        ...rawTabs[index],
        tabKey: this._tabIdMap[index]
      }))
    }
  },
  watch: {
    activeIndex(key) {
      if(this.tabs && this.tabs.length && key) {
        this.setActiveSrc(key, false)
      }
    },
    tabs(newTabs) {
      // 过滤条件变化(如呼入呼出、工单开关)导致 tabs 变化, 当前激活 tab 被过滤掉时切到第一个
      if(!newTabs || !newTabs.length) {
        this.activeIndex = undefined
        return
      }
      const exists = newTabs.some(tab => tab.tabKey === this.activeIndex)
      if(!exists) {
        this.activeIndex = newTabs[0].tabKey
      }
    },
    item() {
      // 通话数据变化, 清空各 tab 的 src 缓存并刷新当前 tab
      // this.srcCache = {}
      if(this.tabs && this.tabs.length) {
        const current = this.tabs.find(tab => tab.tabKey === this.activeIndex)
        const targetKey = current ? current.tabKey : this.tabs[0].tabKey
        if(targetKey === this.activeIndex) {
          this.setActiveSrc(targetKey, true, true)
        } else {
          // 切换激活 tab, 由 activeIndex watcher 处理(srcCache 已清空会重新加载)
          this.activeIndex = targetKey
        }
      }
    }
  },
  created() {
    if(this.tabs && this.tabs.length) {
      this.activeIndex = this.tabs[0].tabKey
    }
  },
  beforeDestroy() {
    this.showIframe = false
    const refs = this.$refs.callPopScreenTabIframe
    const iframeList = Array.isArray(refs) ? refs : (refs ? [refs] : [])
    iframeList.forEach((iframe) => {
      this.removeFrame(iframe)
    })
  },
  methods: {
    // 设置当前激活 tab 对应 iframe 的地址
    // force: 强制刷新(如通话数据变化)
    // 否则根据 tab 配置的 is_refresh 决定: 1-切换时刷新, 0-切换时不刷新(复用缓存)
    setActiveSrc(key, force, isSwitchCall = false) {
      const tabItem = this.tabs.find(tab => tab.tabKey === key) || {}
      const needRefresh = force || Number(tabItem.is_refresh) === 1
      if(needRefresh && !isSwitchCall) {
        this.$set(this.reloadCount, key, (this.reloadCount[key] || 0) + 1)
        this.$set(this.srcCache, key, this.getUrl(key))
      } else {
        // 首次加载, 初始化 src 缓存
        this.$set(this.srcCache, key, this.getUrl(key))
      }
    },
    getUrl(key) {
      const tabItem = this.tabs.find(tab => tab.tabKey === key) || {}
      const { recordData = {} } = this.item
      const { params } = tabItem || {}
      const searchArr = []
      if(params && Array.isArray(params)) {
        params.forEach((item) => {
          if(item.type === 2) {
            searchArr.push(`${item.id}=${item.value}`)
          // } else if(isValidVal(recordData[item.value])){
          } else {
            const val = _.get(recordData, item.value)
            searchArr.push(`${item.id}=${isValidVal(val) ? val : ''}`)
          }
        })
      }
      if(tabItem.type === 'system') {
          if(tabItem.system_url && tabItem.system_url.indexOf('?') > -1){
            return tabItem.system_url + '&' + searchArr.join('&')
          }else if(tabItem.system_url){
            return tabItem.system_url + '?' + searchArr.join('&')
          }else {
            return ''
          }
        } else {
        if(tabItem.value && tabItem.value.indexOf('?') > -1){
          return tabItem.value + '&' + searchArr.join('&')
        }else if(tabItem.value){
          return tabItem.value + '?' + searchArr.join('&')
        }else {
          return ''
        }
      }
    },
    // 清除iframe及占用内存
    removeFrame(iframe) {
      let el = iframe;
      // 取消窗口监听事件
      if (el) {
        el.src = "about:blank";
        if (el.contentWindow) {
          try {
            el.contentWindow.document.write('');
            el.contentWindow.document.clear();
            el.contentWindow.close()
          } catch(e){
            // todo
          }
        }
        const p = el.parentNode;
        if(p){
            p.removeChild(el);
        }
        try {
          window.CollectGarbage()
        } catch (e) {
          // todo
        }
        el = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pannel {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid #EBEDF0;
  &.noExpand {
    flex: unset!important;
    height: 40px!important;
    .content {
      display: none;
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    height: 40px;
    border-bottom: 1px solid #EBEDF0;
    .header-menu {
      flex: 1;
      width: 0;
      height: 100%;
      .tabs {
        width: 100%;
        height: 100%;
        padding: 0 12px;
        /deep/ .el-tabs__header {
          height: 100%;
          margin: 0;
        }
        /deep/ .el-tabs__nav-wrap::after {
          display: none;
        }
        /deep/ .el-tabs__content {
          display: none;
        }
      }
    }
    .expand-btn {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 100%;
      cursor: pointer;
    }
  }
  .content {
    width: 100%;
    flex: 1;
    padding: 1px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/pannel/index.vue